document.addEventListener("DOMContentLoaded", (event) => {

   //Open social media links in New tab
    var links = document.querySelectorAll('.footer-block__details-content a');
    
    links.forEach(function(link) {
        link.setAttribute('target', '_blank');
    });

    var sectionHeader = document.querySelector('.section-header');
    var announcementBar = document.querySelector('.announcement-bar-section');
    var body = document.querySelector('body');
  
    var sectionHeaderHeight = sectionHeader.offsetHeight;
    if (announcementBar) {
    var announcementBarHeight = announcementBar.offsetHeight;
    var totalPadding = sectionHeaderHeight + announcementBarHeight;
    }

  if (window.location.pathname === "/") {
    document.body.classList.add("light-variant");
    if (announcementBar) {
    sectionHeader.style.top = announcementBarHeight + 'px';
    }

  } else {
    document.body.classList.add("dark-variant");

    //Anouncement Bar Padding Adjustment 
    if (announcementBar) {
    body.style.paddingTop = totalPadding + 'px';
    sectionHeader.style.top = announcementBarHeight + 'px';
    }

  }

  var e = document.querySelector(".header-wrapper");
  var s = e.offsetTop;

  window.addEventListener("scroll", function () {
    if (window.pageYOffset > s) {
      e.classList.add("sticky-header");
    } else {
      e.classList.remove("sticky-header");
    }
  });

  //home page video play pause on hover

 const videoplaypause = document.querySelectorAll(".video-play-pause"); 
  videoplaypause.forEach(function (link) {
    const video = link.querySelector("video");
  
    link.addEventListener("mouseover", function () {
      video.currentTime = 0;
      const playPromise = video.play();
      if (playPromise !== null) {
        playPromise.catch(() => {
        });
      }
    });
  
    link.addEventListener("mouseout", function () {
      video.pause();
      video.currentTime = 0;
    });
  });
  
  //end
  //product details page video play pause on hover
  var pvideoplaypause = document.querySelectorAll(".video-play-pause");
  pvideoplaypause.forEach(function (link) {
    var video = link.querySelector("video");

    link.addEventListener("mouseover", function () {
      video.currentTime = 0;
      video.play();
    });

    link.addEventListener("mouseout", function () {
      video.pause();
      video.currentTime = 0;
    });
  });
  //end
  //product page tabed video
  const tabbedMediaSections = document.querySelectorAll(".tabbed-media");
  tabbedMediaSections.forEach((section) => {
    const tabs = section.querySelectorAll(".tabbed-media-lists ul li");
    tabs.forEach((tab) => {
      tab.addEventListener("click", function (e) {
        e.preventDefault();
        const index = parseInt(
          this.querySelector("a").getAttribute("data-index")
        );
        const tabbedGroups = section.querySelectorAll(".tabbed-source-group");
        const activeTab = section.querySelector(
          ".tabbed-media-lists ul li.active"
        );
        if (activeTab) {
          const activeIndex = parseInt(
            activeTab.querySelector("a").getAttribute("data-index")
          );
          if (index !== activeIndex) {
            tabbedGroups[activeIndex]?.classList.add("hidden");
            tabbedGroups[index]?.classList.remove("hidden");
            activeTab.classList.remove("active");
            this.classList.add("active");
            const videos = section.querySelectorAll(".videos");
            videos.forEach((video) => {
              video.pause(); // Pause all videos
            });
            const currentVideo = tabbedGroups[index]?.querySelector(".videos");
            if (currentVideo) {
              currentVideo.play(); // Play the current video
            }
          }
        }
      });
    });
  });
  //end
  //product page shipping and returns accordian
  var acc = document.getElementsByClassName("accordion");

  for (var i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      // Close other open accordion panels
      var openPanels = document.querySelectorAll(".accordion.active");
      openPanels.forEach(
        function (openPanel) {
          if (openPanel !== this) {
            openPanel.classList.remove("active");
            var openPanelContent = openPanel.nextElementSibling;
            openPanelContent.style.maxHeight = null;
            openPanelContent.classList.remove("open");
          }
        }.bind(this)
      );

      // Toggle active class on clicked accordion
      this.classList.toggle("active");

      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        // Slide up
        panel.style.maxHeight = null;
        panel.classList.remove("open");
      } else {
        // Slide down
        panel.style.maxHeight = panel.scrollHeight + "px";
        panel.classList.add("open");
      }
    });
  }

  //end

  //product page feature video section
  const featureMediaVideos = document.querySelectorAll(".feature-media-video");
  const addBtnClick = document.querySelectorAll(
    ".feature-w-zoom .read-more-pop, .video-icons-block .read-more-pop, .product-teaser-block .column .read-more-pop"
  );
  const cardPopupOverlay = document.querySelectorAll(
    ".feature-w-zoom .card-popup-overlay, .video-icons-block .card-popup-overlay, .product-teaser-block .column .card-popup-overlay"
  );
  const featureVideo = document.querySelectorAll(
    ".feature-w-zoom .feature-video, .video-icons-block .feature-video, .product-teaser-block .column .feature-video"
  );
  const videoIcon = document.querySelectorAll(
    ".feature-w-zoom .video-icon, .video-icons-block .video-icon, .product-teaser-block .column .video-icon"
  );
  const readMore = document.querySelectorAll(
    ".feature-w-zoom .secondary-btn,.video-icons-block .secondary-btn"
  );
  if (featureVideo) {
    if (screen.width < "991") {
      featureVideo.forEach(function (feture) {
        feture.pause();
      });
    }
  }
  if (featureMediaVideos) {
      const featureWithZoom = document.querySelector("#feature_w_zoom");
      const video = document.querySelector(".feature-video");
      const featureWithZoom_class = document.querySelector(".feature-media-wrap");
      
      if ((featureWithZoom && video) || featureWithZoom_class) {
        const observerCallback = (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio >= 0.7) {
              // At least 50% of the video is visible, play the video
              video.play();
              if (featureWithZoom_class) {
                featureWithZoom_class.classList.remove("click-action-card");
              }
            } else {
              // Less than 50% of the video is visible, pause the video
              video.pause();
              if (featureWithZoom_class) {
                featureWithZoom_class.classList.add("click-action-card");
              }
            }
          });
        };
      
        const observerOptions = {
          root: null,
          rootMargin: "0px",
          threshold: 0.7 // Trigger intersection when at least 50% of the target is visible
        };
      
        const observer = new IntersectionObserver(
          observerCallback,
          observerOptions
        );
      
        observer.observe(featureWithZoom || featureWithZoom_class);
      }

  }
  if (videoIcon) {
    videoIcon.forEach(function (videoMobile) {
      videoMobile.addEventListener("click", function () {
        videoMobile.classList.toggle("play-video-icons");
        // Find the container of the clicked icon
        const container = videoMobile.closest(
          ".feature-w-zoom, .video-icons-block, .product-teaser-block .column"
        );

        // Find the video within the same container
        const featureVideoInSection = container.querySelector(".feature-video");

        if (featureVideoInSection) {
          if (featureVideoInSection.paused) {
            featureVideoInSection.play();
          } else { 
            featureVideoInSection.pause();
          }
        }
      });
    });
  }
  if (addBtnClick) {
    addBtnClick.forEach(function (popup) {
      popup.addEventListener("click", function (e) {
        console.log("first");
        const container = e.currentTarget.closest(
          ".feature-w-zoom, .video-icons-block, .product-teaser-block .column"
        );
        const overlay = container.querySelector(".card-popup-overlay");
        popup.classList.toggle("click-action-btn");
        overlay.classList.toggle("open-overlay");
        document.documentElement.classList.toggle("overflow-x-hidden");
      });
    });
  }
  if (readMore) {
    readMore.forEach(function (MobilePopup) {
      MobilePopup.addEventListener("click", function (e) {
        console.log("second");
        const container = e.currentTarget.closest(
          ".feature-w-zoom, .video-icons-block, .product-teaser-block .column"
        );
        const overlay = container.querySelector(".card-popup-overlay");
        MobilePopup.classList.toggle("click-action-btn");
        overlay.classList.toggle("open-overlay");
        document.documentElement.classList.toggle("overflow-x-hidden");
      });
    });
  }
  //end

  //Desktop Navigation
  let prevScrollPos = window.pageYOffset;
  // Listen for scroll events
    window.addEventListener("scroll", function() {
      const currentScrollPos = window.pageYOffset;
      if (currentScrollPos > prevScrollPos && currentScrollPos > 0) {
          // Scrolling down
          document.querySelector(".section-header").classList.add("shrink", "nav-up");
          document.querySelector(".section-header").classList.remove("nav-down");
      } else {
        // Scrolling up or at the top
        document.querySelector(".section-header").classList.remove("nav-up");
        
        // Check if at the top of the page
        if (currentScrollPos === 0) {
            document.querySelector(".section-header").classList.remove("nav-down");
        } else {
            document.querySelector(".section-header").classList.add("nav-down");
        }
    }
      // Update previous scroll position
      prevScrollPos = currentScrollPos;
  });

  //Desktop Navigation End

  //Close Icon Mobile Drawer
  var closeIcon = document.querySelector(".close-icon");
  var drawerIcon = document.querySelector(".icon-hamburger");
  var summaryElement = document.querySelector(".header__icon--summary");
  var headerGroupElement = document.querySelector(".shopify-section-group-header-group");
  var bodyElement = document.querySelector("body");
  var htmlElement = document.querySelector("html");

  drawerIcon.addEventListener("click", function () {
    htmlElement.classList.add("overflow-hidden-tablet");
  });
  closeIcon.addEventListener("click", function () {
    var menuElement = document.querySelector("details");

    if (menuElement) {
      menuElement.classList.remove("menu-opening");
      menuElement.removeAttribute("open");
      headerGroupElement.classList.remove("menu-open");
      bodyElement.classList.remove("overflow-hidden-tablet");
      htmlElement.classList.remove("overflow-hidden-tablet");
      summaryElement.setAttribute("aria-expanded", "false");
    }
  });
  //Close icon end

  //Video Transition
  function isPartiallyInViewport(element) {
    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  // Select the element to watch
  const statQuoteCollage = document.querySelector(".stat-quote-collage");
  const videoSection = document.querySelector(".shopify-section.video-section");

  // Add an event listener for scroll
  window.addEventListener("scroll", () => {
    if(statQuoteCollage) {
      if(videoSection){
        if (isPartiallyInViewport(statQuoteCollage)) {
          // Element is partially in viewport, add your desired class
          videoSection.classList.add("video-transition-active");
        } else {
          videoSection.classList.remove("video-transition-active");
        }
      }
    }
  });
});
